import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMAdminDiscountAsync,
  deleteOMAdminDiscountAsync,
  editOMAdminDiscountAsync,
  getOMAdminDiscountAsync,
} from "../../../store/services/orderManagementService";
const AdminDiscount = () => {
  const dispatch = useDispatch();
  const {
    getOMAdminDiscountStatus,
    getOMAdminDiscountError,
    getOMAdminDiscountData,
    addOMAdminDiscountStatus,
    addOMAdminDiscountData,
    addOMAdminDiscountError,

    editOMAdminDiscountStatus,
    editOMAdminDiscountError,
    editOMAdminDiscountData,

    deleteOMAdminDiscountData,
    deleteOMAdminDiscountStatus,
    deleteOMAdminDiscountError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMAdminDiscountAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMAdminDiscountData?.length
    ? getOMAdminDiscountData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedAdminDiscount, setSelectedAdminDiscount] = useState();
  const [addAdminDiscountMode, setAddAdminDiscountMode] = useState(false);
  const [addAdminDiscountData, setAddAdminDiscountData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedAdminDiscount", selectedAdminDiscount);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMAdminDiscountStatus === asyncStatus.SUCCEEDED) {
      setAddAdminDiscountMode(false);
      setSaveDisabled(true);
      setAddAdminDiscountData();
    }
  }, [, addOMAdminDiscountStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMAdminDiscountAsync(selectedAdminDiscount?.discount_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMAdminDiscountStatus === asyncStatus.SUCCEEDED || deleteOMAdminDiscountStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedAdminDiscount();
    }
  }, [, deleteOMAdminDiscountStatus]);
  useEffect(() => {
    if (editOMAdminDiscountStatus === asyncStatus.SUCCEEDED) {
      setSelectedAdminDiscount();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMAdminDiscountStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this admin discount?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Admin Discount"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Admin Discount
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddAdminDiscountMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addAdminDiscountMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addAdminDiscountMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddAdminDiscountMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addAdminDiscountMode || !selectedAdminDiscount}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMAdminDiscountStatus === asyncStatus.LOADING ||
                  editOMAdminDiscountStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addAdminDiscountData) {
                    dispatch(addOMAdminDiscountAsync(addAdminDiscountData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedAdminDiscount, ...editData };
                    delete a.id;
                    dispatch(editOMAdminDiscountAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "discount_id", headerName: "ID", flex: true },
                  { field: "discount_name", headerName: "Admin Discount", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedAdminDiscount(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMAdminDiscountStatus === asyncStatus.IDLE ||
                  getOMAdminDiscountStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addAdminDiscountMode ? (
              <InputWithBtnLayoutComp
              error={addOMAdminDiscountError}
                inputArray={[
                  {
                    label: "Admin Discount:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddAdminDiscountData({
                            ...addAdminDiscountData,
                            discount_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddAdminDiscountData({
                            ...addAdminDiscountData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedAdminDiscount ? (
              <InputWithBtnLayoutComp
              error={editOMAdminDiscountError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedAdminDiscount?.discount_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "AdminDiscount:",
                    comp: (
                      <InputComp
                        key={selectedAdminDiscount?.discount_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            discount_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedAdminDiscount?.discount_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedAdminDiscount?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedAdminDiscount?.is_active || editData?.is_active}
                        defaultChecked={selectedAdminDiscount?.is_active || editData?.is_active}
                        // checked={selectedAdminDiscount?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any admin discount</Typography>
              <Typography color={"red"} fontSize={12}>{getOMAdminDiscountError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedAdminDiscount(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedAdminDiscount(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default AdminDiscount;
